// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__1nK8g","content":"LayoutSettings_content__2Am7W"};